import React, { memo } from "react";
import { Link } from "react-router-dom";
import type { DiscoverPageItemDetail } from "@highnote/server/src/functions/handlers/discover/types";
import { getSpaceUrl } from "../shared";
import { Byline } from "../Byline";
import "./styles.scss";

export const SquareSpaceTile = memo(
  ({ itemDetail }: { itemDetail: DiscoverPageItemDetail | null }) => {
    const url = itemDetail?.entityId
      ? getSpaceUrl(itemDetail.entityId, itemDetail.shareKey)
      : null;

    const content = (
      <div className="square-space-tile">
        <div className="square-space-tile-image">
          {itemDetail?.squareImageUrl && (
            <img
              src={itemDetail.squareImageUrl}
              alt={itemDetail?.title ?? ""}
            />
          )}
        </div>
        <div className="square-space-tile-info">
          <div className="square-space-tile-text">
            {itemDetail?.title && (
              <span className="square-space-tile-name">{itemDetail.title}</span>
            )}
            {itemDetail?.memberCount != null && (
              <span className="square-space-tile-member-count">
                {itemDetail.memberCount} Members
              </span>
            )}
          </div>
          {itemDetail?.createdByName && (
            <Byline
              picture={itemDetail.createdByPicture}
              name={itemDetail.createdByName}
            />
          )}
        </div>
      </div>
    );

    if (url) {
      return (
        <Link to={url} className="square-space-tile-link">
          {content}
        </Link>
      );
    }

    return content;
  },
);
SquareSpaceTile.displayName = "SquareSpaceTile";
